/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import {  Component, ViewChild, ChangeDetectorRef } from '@angular/core';
import {MessageService, Message} from 'primeng/api';
import { ApiService } from '../../shared/api.service';
import { CountriesService } from '../../@core/data/countries.service';
import { FormBuilder, FormGroup,Validators} from '@angular/forms';
import { NbDateService,NbDialogService,NbToastrService } from '@nebular/theme';
import { TermsComponent } from './terms.component';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import {ConfirmationService} from 'primeng/api';
import { ConfirmPassComponent } from './confirmPass.component';
import { Router } from '@angular/router';
import { MatStepper } from '@angular/material';
//import { MatRadioModule } from '@angular/material';
import { config } from './../../../../config';

@Component({
  selector: 'nb-register',
  styleUrls: ['./register.component.scss'],
  templateUrl: './register.component.html',
  providers: [MessageService, ConfirmationService]
})
export class RegisterComponent{
	@ViewChild('stepper') stepper: MatStepper;
	serverUrl = config.serverUrl;
	email:any;
	RegisterForm: FormGroup;
	alertflag = 0;///this is for  submit button
	messgealertflag = 0;
	messages;
	validation_messages;
	selectedGender;
	selectedOption;
	max = new Date();
	date;
	captcha;
	country_id;
	profile_info;
	svg:SafeHtml;
 	captchaText;
	captchaId;
	captchaUrl;
	values = '';
	emailAlert = false;
	display: boolean = false;
	displayNo: boolean = false;
	emailValue;

	Countries: any [];
	selectedCountry :any;
	permCountry:any;
	private emailCheckTimer: any;

	readonly emailValidate = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
	readonly charValidate = /^[.a-zA-Z ]*$/;
	readonly postalValidate = /^[a-zA-Z0-9 ]+$/;
	readonly mobileValidate =/^[0-9]\d{5,12}$/;
	readonly passwordValidate = /^[A-Za-z0-9!@#$%^&*()_]{6,}$/;

	//NEW REG
	isLinear = false;
	firstFormGroup : FormGroup;
	secondFormGroup : FormGroup;
	initials_gender;
	thirdFormGroup : FormGroup;
	fourthFormGroup : FormGroup;
	// public min = new Date(1980, 0, 1, 10, 30);
	// public maxnew = new Date(new Date().setDate(new Date().getDate()-1));
	whatsapp_no;
	whatsapp_Code;
	disable_checked = true;
	sameWhatsapp = false;
	countryradio = true;
	country_name: any;
	
  	constructor(
		private fb: FormBuilder,
		protected dateService: NbDateService<Date>,
		protected api : ApiService,
		protected countries :CountriesService,
		private dialogService: NbDialogService, //on submit dialog box
		private messageService: MessageService,
		private toastrService: NbToastrService,
		private sanitizer: DomSanitizer,
		private confirmationService: ConfirmationService,
		private router : Router,
		private ref: ChangeDetectorRef,

    ){  
		this.Countries = this.countries.getData();
	}
	
	ngOnInit() {
		this.router.navigate(['apply'])
		this.api.getIpAddress().subscribe(data => {
			this.country_name = data['country'];
			if(data.country=='India'){
				this.thirdFormGroup.controls.locationCtrl.patchValue("WITHIN");
				// this.fourthFormGroup.controls.phonecodeCtrl.patchValue("+91");
			}else{
				this.thirdFormGroup.controls.locationCtrl.patchValue("OUTSIDE");
			}
		});

		this.loadCaptcha();

		//NEW
		this.firstFormGroup = this.fb.group({
			firstNameCtrl: ['', [ Validators.pattern(this.charValidate), Validators.required, Validators.maxLength(70),Validators.minLength(3)]],
			LastNameCtrl: ['', [ Validators.pattern(this.charValidate), Validators.required, Validators.maxLength(70),Validators.minLength(2),Validators.pattern(/^\S*$/)]],
		});

		this.secondFormGroup = this.fb.group({
			genderCtrl: ['', Validators.required]
		});

		this.thirdFormGroup = this.fb.group({
			locationCtrl:['', Validators.required],
		});

		this.fourthFormGroup= this.fb.group({
			emailCtrl : ['', [ Validators.required, Validators.pattern(this.emailValidate)]],
			passwordCtrl : ['',[Validators.required, Validators.pattern(this.passwordValidate)]],
			repasswordCtrl : ['',[Validators.required, Validators.pattern(this.passwordValidate)]],
			phonecodeCtrl:['',Validators.required],
			phoneCtrl:['', [ Validators.required, Validators.pattern(this.mobileValidate)]],
			dobCtrl:['', Validators.required],
			captchaCtrl:['', Validators.required],
		});

	}


	ChangeStudentNamePop(){
		this.confirmationService.confirm({
			message: 'You cannot edit Your Name Once Registered.',
			header: 'Confirmation',
			icon: 'pi pi-exclamation-triangle',
			accept: () => {
				this.firstFormGroup.get('firstNameCtrl').disable();
				
			},
			reject: () => {
				this.firstFormGroup.get('firstNameCtrl').enable();
			}
		});
	}

	radioChange(event) {
		if(event){
			if(event=='Male'){
				this.initials_gender = "Mr.";
				this.secondFormGroup.patchValue({
					genderCtrl : event
				})
			}else if(event=='Female'){
				this.initials_gender = "Ms.";
				this.secondFormGroup.patchValue({
					genderCtrl : event
				})
			}
			if(event=='WITHIN'){
				this.fourthFormGroup.controls.phonecodeCtrl.patchValue("+91");
			}
			 if(event=='OUTSIDE'){
				this.fourthFormGroup.patchValue({
					phonecodeCtrl : null
				})
			}
		}
		//this.ref.detectChanges();
		this.stepper.next();
	}

	radioChangepre() {
		this.stepper.previous();
	}

	changeradio(value){
		if(this.countryradio == true){
			this.confirmationService.confirm({
				message: 'If you want to change your location then select below check box and change the value.',
				header: 'Confirmation',
				icon: 'pi pi-exclamation-triangle',
				rejectVisible : false,
				acceptLabel: 'Ok'
			});
		}else if(this.countryradio == false){
			this.thirdFormGroup.controls.locationCtrl.patchValue(value);
			
			
			this.ref.detectChanges();
		}
	}

	ChangeLocation(event){
		if(event.target.checked == true){
			this.countryradio = false
		}else if(event.target.checked == false){
			this.countryradio = true
		}
		//this.ref.detectChanges();
	}
	loadCaptcha(){
		this.api.getCaptcha().subscribe(
			(data: any) => {
				this.captchaId = data['data']['captchaId'];
				this.captchaUrl = data['data']['captchaUrl'];
			},
			err => console.error(err));
	}

	reloadcaptcha(){
		this.loadCaptcha();
	}

	checkcaptcha(duration,status){
		if(!this.fourthFormGroup.controls.captchaCtrl.value){
			this.toastrService.show(
				`Please enter the captcha`, {duration},{status}
			);
			this.validation_messages =  'Please enter the captcha';
			this.fourthFormGroup.controls.captchaCtrl.markAsDirty();
		}
	}

	checkpassword(duration,status){
		if(this.fourthFormGroup.controls.passwordCtrl.value != this.fourthFormGroup.controls.repasswordCtrl.value){		

			this.toastrService.show(       
				'Password doesnt match ! ! ', {duration},{status}
      		);
			this.validation_messages =  "Password doesn't match!";
			this.fourthFormGroup.controls.passwordCtrl.markAsDirty();
		}
	}

	onClose(){
    	this.messgealertflag = 0;
	}

	onEmailClose(){
		this.emailAlert = false;
	}

	close() {
		this.alertflag = 0;
	}

	//to check which form control is invalid
	public findInvalidControls(controls) {
		const invalid = [];
	   
		for (const name in controls) {
			if (controls[name].invalid) {
				invalid.push(name);
			}
		}
		return invalid;
	  }

	onProceed(duration,status){
		
		var check_validation;
		this.fourthFormGroup.controls.emailCtrl.markAsDirty();
		this.fourthFormGroup.controls.passwordCtrl.markAsDirty();
		this.fourthFormGroup.controls.repasswordCtrl.markAsDirty();
		this.fourthFormGroup.controls.dobCtrl.markAsDirty();
		this.fourthFormGroup.controls.phonecodeCtrl.markAsDirty();
		this.fourthFormGroup.controls.phoneCtrl.markAsDirty();
		this.fourthFormGroup.controls.captchaCtrl.markAsDirty();

		var error=this.findInvalidControls(this.fourthFormGroup.controls)
		
		if(this.fourthFormGroup.controls.passwordCtrl.value == this.fourthFormGroup.controls.repasswordCtrl.value){
			if(this.fourthFormGroup.valid){	
				if(this.fourthFormGroup.controls.captchaCtrl.value){
					check_validation = true;
					this.alertflag = 0;
				}else{
					this.reloadcaptcha();
					this.toastrService.show(
						`Please enter the captcha`, {duration},{status}
					);
				}
			}else{			
				this.reloadcaptcha();			
				check_validation = false;
				this.alertflag = 1;
				this.validation_messages =  "Fill in the all required details !";
			}
		}else{
			this.alertflag = 1;
			this.toastrService.show(       
				`Password doesn't match ! ! `, {duration},{status}
			);
			this.validation_messages =  "Password doesn't match!";

		}

		var phonecode = this.fourthFormGroup.controls.phonecodeCtrl.value.split("+");
		if(check_validation){
			
			if(this.sameWhatsapp){
				var phonecode = this.fourthFormGroup.controls.phonecodeCtrl.value.split("+");
				this.whatsapp_no = this.fourthFormGroup.controls.phoneCtrl.value;
				this.whatsapp_Code = phonecode[1];
			}else{
				this.whatsapp_no = null;
				this.whatsapp_Code = null;
			}

			this.alertflag = 0;
			this.dialogService.open(TermsComponent, {
				context: {
					userName : this.firstFormGroup.controls.firstNameCtrl.value,
					Surname: this.firstFormGroup.controls.LastNameCtrl.value,
					Gender : this.secondFormGroup.controls.genderCtrl.value,
					current_location : this.thirdFormGroup.controls.locationCtrl.value,
					userEmail : this.fourthFormGroup.controls.emailCtrl.value,
					userPassword : this.fourthFormGroup.controls.passwordCtrl.value,
					userDob : this.fourthFormGroup.controls.dobCtrl.value,
					userCountryCode : phonecode[1],
					userContactNo : this.fourthFormGroup.controls.phoneCtrl.value,
					whatsapp_phoneCode : this.whatsapp_Code,
					whatsapp_No : this.whatsapp_no,
					captchaId : this.captchaId,
					captcha : this.fourthFormGroup.controls.captchaCtrl.value,
				},
			});
		}else{
			this.alertflag = 1;
			if(this.validation_messages != null){
				this.messages = this.validation_messages;
			}else{
				this.messages = "Your form is not filled please fill completely";
			}
		}

	}

	onKeyPress(event: any) {
		this.emailAlert = false;

		if (this.emailCheckTimer) {
			clearTimeout(this.emailCheckTimer);
		}

		const value = this.fourthFormGroup.controls.emailCtrl.value;

		if (!value || !this.emailValidate.test(value)) {
			return;
		}

		this.emailCheckTimer = setTimeout(() => this.checkEmailAvailable(value), 600);
	};

	private checkEmailAvailable(value: string) {
		this.api.emailValues(value)
			.subscribe(
				(data: any) => {
				if(data['status'] == 400){  
					this.confirmationService.confirm({
						message: 'Your email id is already exists in our database!!! Do you want to login on this website using same id and password??',
						header: 'Confirmation',
						icon: 'pi pi-exclamation-triangle',
						accept: () => {
							this.display = true;						
						},
						reject: () => {
							this.emailValue = this.fourthFormGroup.controls.emailCtrl.value;
							this.displayNo = true;
						}
					});
				}else{
				}       
				err => console.error(err)
			});
	};

	onNoSelect(event : any){
		if(event.target.checked == true){
			this.sameWhatsapp = true;
		}else{
			this.sameWhatsapp = false;
		}
	}

	// ChangeNumber(event){
	// 	this.disable_checked = false;
	// }
}

    // ngOnInit() {

    //   this.buildForm1();     
     
    //   this.RegisterForm = this.fb.group({
    //     firstNameCtrl: ['', [ Validators.pattern(this.charValidate), Validators.required, Validators.maxLength(70),Validators.minLength(3)]],
    //    LastNameCtrl: ['', [ Validators.pattern(this.charValidate), Validators.required, Validators.maxLength(70),Validators.minLength(3)]],
    //     emailCtrl: ['', [ Validators.required, Validators.pattern(this.emailValidate)]], // Validators.pattern("^[0-9]*$")
	// 	passwordCtrl:['',[Validators.required, Validators.pattern(this.passwordValidate)]],
	// 	repasswordCtrl:['',[Validators.required, Validators.pattern(this.passwordValidate)]],
	// 	dobCtrl:['',[Validators.required]],
	// 	genderCtrl: [ '', [ Validators.required]],
	// 	countryCtrl:['', Validators.required],
    //     cityCtrl:['', [ Validators.required, Validators.maxLength(30),Validators.minLength(2)]],
    //     PostCodeCtrl:['', [ Validators.required, Validators.pattern(this.postalValidate), Validators.maxLength(10),Validators.minLength(5)]],
	// 	moCountryCtrl:['', Validators.required],
	// 	mophonecodeCtrl:['',Validators.required ],
    //     phoneCtrl:['', [ Validators.required, Validators.pattern(this.mobileValidate)]],
	// 	captchaCtrl:['', Validators.required],
	// 	my_radio_option :['', Validators.required],
    //   });
    // }
              
    // private buildForm1() : void{
    //   this.api.getCaptcha()
    //   .subscribe(
    //     (data: any) => {  
    //       this.captchaText = data['data']['captchaText'];
    //       this.captcha =  data['data']['captchadata'];
    //       this.svg = this.sanitizer.bypassSecurityTrustHtml(this.captcha);         
    //     err => console.error(err)
    //   });
    // }
	
  	// checkcaptcha(duration,status){
	// 	if(!(this.RegisterForm.controls.captchaCtrl.value == this.captchaText)){		
	// 		this.toastrService.show(       
	// 			`checkcaptcha doesn't match ! ! `, {duration},{status}
    //   		);
	// 		this.validation_messages =  "checkcaptcha doesn't match!";
	// 		this.RegisterForm.controls.captchaCtrl.markAsDirty();
			
	// 	}
	// }

	// reloadcaptcha(){
	// 	this.api.getCaptcha()
	// 	.subscribe(
	// 		(data: any) => {  
	// 			this.captchaText = data['data']['captchaText'];
	// 			this.captcha =  data['data']['captchadata'];
	// 			this.svg = this.sanitizer.bypassSecurityTrustHtml(this.captcha);         
	// 		err => console.error(err)
	// 	});
	// }

	// checkpassword(duration,status){
	// 	if(this.RegisterForm.controls.passwordCtrl.value != this.RegisterForm.controls.repasswordCtrl.value){		

	// 		this.toastrService.show(       
	// 			'Password doesnt match ! ! ', {duration},{status}
    //   		);
	// 		this.validation_messages =  "Password doesn't match!";
	// 		this.RegisterForm.controls.passwordCtrl.markAsDirty();
	// 	}
	// }

	// onSubmit(duration,status){
		
	// 	var check_validation;
	// 	this.RegisterForm.controls.firstNameCtrl.markAsDirty();
	// 	this.RegisterForm.controls.LastNameCtrl.markAsDirty();  
	// 	this.RegisterForm.controls.emailCtrl.markAsDirty();
	// 	this.RegisterForm.controls.passwordCtrl.markAsDirty();
	// 	this.RegisterForm.controls.repasswordCtrl.markAsDirty();
	// 	this.RegisterForm.controls.dobCtrl.markAsDirty();
	// 	this.RegisterForm.controls.genderCtrl.markAsDirty();  
	// 	this.RegisterForm.controls.countryCtrl.markAsDirty();		
	// 	this.RegisterForm.controls.cityCtrl.markAsDirty();   
	// 	this.RegisterForm.controls.PostCodeCtrl.markAsDirty();
	// 	this.RegisterForm.controls.moCountryCtrl.markAsDirty();
	// 	this.RegisterForm.controls.mophonecodeCtrl.markAsDirty();
	// 	this.RegisterForm.controls.phoneCtrl.markAsDirty();
	// 	this.RegisterForm.controls.captchaCtrl.markAsDirty();
	// 	this.RegisterForm.controls.my_radio_option.markAsDirty();
		
		
		
	// 					if(this.RegisterForm.controls.passwordCtrl.value == this.RegisterForm.controls.repasswordCtrl.value){
	// 						if(this.RegisterForm.valid){	
	// 							if(this.RegisterForm.controls.captchaCtrl.value == this.captchaText){	
	// 								check_validation = true;
	// 								this.alertflag = 0;
	// 							}else{
	// 								this.reloadcaptcha();
	// 								this.toastrService.show(       
	// 									`checkcaptcha doesn't match ! ! `, {duration},{status}
	// 									);	
	// 							}			
	// 						}else{			
	// 							this.reloadcaptcha();			
	// 							check_validation = false;
	// 							this.alertflag = 1;
	// 							this.validation_messages =  "Fill in the all required details !";
	// 						}
	// 					}else{
	// 						this.alertflag = 1;
	// 						this.toastrService.show(       
	// 							`Password doesn't match ! ! `, {duration},{status}
	// 								);
	// 						this.validation_messages =  "Password doesn't match!";

	// 					}
	// 				if(check_validation){
	// 					this.alertflag = 0;
	// 						this.dialogService.open(TermsComponent, {
	// 							context: {
	// 								userName : this.RegisterForm.controls.firstNameCtrl.value,
	// 								Surname: this.RegisterForm.controls.LastNameCtrl.value,
	// 								userEmail : this.RegisterForm.controls.emailCtrl.value,
	// 								userPassword : this.RegisterForm.controls.passwordCtrl.value,
	// 								userDob : this.RegisterForm.controls.dobCtrl.value,
	// 								Gender : this.RegisterForm.controls.genderCtrl.value,
	// 								Country:this.RegisterForm.controls.countryCtrl.value,
	// 								userCity: this.RegisterForm.controls.cityCtrl.value,
	// 								postal_code : this.RegisterForm.controls.PostCodeCtrl.value,
	// 								userCountryCode : this.RegisterForm.controls.mophonecodeCtrl.value,
	// 								userContactNo : this.RegisterForm.controls.phoneCtrl.value,
	// 								user_option : this.RegisterForm.controls.my_radio_option.value,
	// 							},
	// 						});
	// 					}else{
	// 					this.alertflag = 1;
	// 					if(this.validation_messages != null){
	// 						this.messages = this.validation_messages;
	// 					}else{
	// 						this.messages = "Your form is not filled please fill completely";
	// 					}
	// 					}
					
						

	// }

  	// onClose(){
    // 	this.messgealertflag = 0;
	// }

	// onEmailClose(){
	// 	this.emailAlert = false;
	// }

	// close() {
	// 	this.alertflag = 0;
	// }

  	// showResponse(event) {
    // 	this.messageService.add({severity:'info', summary:'Succees', detail: 'User Responded', sticky: true});
	// }

	// onValueChange(event){
	// 	var phonecode;
	// 	var permittedValues = this.Countries.map(function(value) {
	// 	if(value.id == event){
	// 	phonecode = value.phonecode;
	// 	}
	// 	});
	// 	if(phonecode!=null || phonecode!=undefined ){
	// 	this.profile_info = phonecode;
	// 	} 
   	// }


